const fmt = {
  currency: (n) => new Intl.NumberFormat("en-ZA", { style: "currency", currency: "ZAR", minimumFractionDigits: 0 }).format(n),
  number: (n) => new Intl.NumberFormat("en-ZA").format(n),
  date: (s) => s ? new Date(s).toLocaleDateString("en-ZA", { month: "short", day: "numeric", year: "numeric" }) : "—",
  pct: (n) => `${n}%`,
};

const STATUS_COLORS = {
  Active: "#22c55e", Delivered: "#22c55e", Collected: "#22c55e", Sufficient: "#22c55e", Good: "#22c55e",
  Pending: "#f59e0b", Processing: "#f59e0b", Partial: "#f59e0b", Warning: "#f59e0b",
  Confirmed: "#3b82f6", Scheduled: "#3b82f6",
  "In Transit": "#06b6d4", Unassigned: "#8b5cf6",
  Overdue: "#ef4444", Cancelled: "#6b7280", Critical: "#ef4444", Low: "#f59e0b",
  Blocked: "#ef4444",
};

const statusColor = (s) => STATUS_COLORS[s] || "#6b7280";

export { fmt, statusColor };
